import { render } from "./LoadingOverlay.vue?vue&type=template&id=96268a12&ts=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__